import React, { useEffect, useState } from "react";
import { Asset, Paragraph, Spacing, Title } from "@sicredi/react";
import styles from "./styles.module.scss";

interface ManutencaoPageProps {
  mensagemHorario?: string;
}

export const ManutencaoPage: React.FC<ManutencaoPageProps> = ({
  mensagemHorario = "A definir",
}) => {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 700);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 576);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <div id={styles.container}>
      <header id={styles.header}>
        <Asset name="padlock" />
        <div>
          <Title as="h1">
            Manutenção <br />
            <span>Programada</span>
          </Title>
        </div>
      </header>

      <Spacing appearance={isMobile ? "xx-small" : "medium"} />

      <div id={styles.content}>
        <Paragraph
          className={styles.content_paragrafo}
          size="large"
          weight="semi-bold"
        >
          Para garantir a qualidade e a segurança dos nossos serviços, estamos
          realizando uma manutenção programada em nosso sistema.
        </Paragraph>

        <Spacing appearance={isMobile ? "xx-small" : "medium"} />

        <div id={styles.content_horario}>
          <Paragraph
            className={styles.content_paragrafo}
            size="large"
            weight="bold"
          >
            {mensagemHorario}
          </Paragraph>
        </div>

        <Spacing appearance={isMobile ? "small" : "large"} />

        <Paragraph
          className={styles.content_paragrafo}
          size="large"
          weight="semi-bold"
        >
          Durante este período, nossos serviços estarão temporariamente
          indisponíveis.
        </Paragraph>

        <Spacing appearance={isMobile ? "xx-small" : "medium"} />

        <Paragraph
          className={styles.content_paragrafo}
          size="large"
          weight="semi-bold"
        >
          Pedimos desculpas por qualquer inconveniente e agradecemos pela sua
          compreensão.
        </Paragraph>
      </div>
    </div>
  );
};
